import { useAtomValue } from 'jotai';
import { selectedPaintRegionGroupId as selectedPaintRegionGroupIdAtom } from '@/components/Analysis/state';

export const useSelectedPaintRegionGroupId = () => {
  const selectedPaintRegionGroupId = useAtomValue(selectedPaintRegionGroupIdAtom);
  return selectedPaintRegionGroupId;
};
